import React from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { SPACING } from "../../theme/constants";

const ActivityFilters = ({
  filters,
  onFilterChange,
  onSearchChange,
  iconMap,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: SPACING.sm,
        mb: SPACING.md,
      }}
    >
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        value={filters.search}
        onChange={onSearchChange}
      />
      <FormControl size="small">
        <InputLabel>Sort By</InputLabel>
        <Select
          value={filters.sortBy}
          label="Sort By"
          onChange={onFilterChange("sortBy")}
        >
          <MenuItem value="createdAt">Date</MenuItem>
          <MenuItem value="activityType">Type</MenuItem>
          <MenuItem value="siteName">Site</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small">
        <InputLabel>Order</InputLabel>
        <Select
          value={filters.order}
          label="Order"
          onChange={onFilterChange("order")}
        >
          <MenuItem value="desc">Descending</MenuItem>
          <MenuItem value="asc">Ascending</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small">
        <InputLabel>Filter by Type</InputLabel>
        <Select
          value={filters.type}
          label="Filter by Type"
          onChange={onFilterChange("type")}
        >
          <MenuItem value="">All</MenuItem>
          {Object.keys(iconMap).map((key) => (
            <MenuItem key={key} value={key}>
              {key.replace(/_/g, " ")}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ActivityFilters;
